import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import "./MealReservationList.css";

import { getMealReservations } from "../../../../actions/mealReservationActions";

class MealReservationList extends React.Component {
    constructor(props) {
        super(props);

        this.weekDays = [];
        this.state = { currentDate: null };
    }

    componentDidMount() {
        const now = new Date();
        const maxDate = new Date(`${now.toISOString().slice(0, 10)} 09:30:30`);
        if (now >= maxDate) now.setDate(now.getDate() + 1);
        let weekDay = (7 + now.getDay() - 1) % 7;
        if (weekDay > 4) now.setDate(now.getDate() + 7 - weekDay);
        weekDay = (7 + now.getDay() - 1) % 7;
        
        this.startDate = "";
        for (let i = 0; i < 5; i++) {
            const dayDiff = i - weekDay;
            const date = new Date(now);
            date.setDate(date.getDate() + dayDiff);
            this.weekDays.push({
                past: dayDiff < 0,
                date: date.toISOString().slice(0, 10)
            });
        }

        this.setState({ currentDate: now.toISOString().slice(0, 10) });
    }

    componentDidUpdate() {
        if (this.state.currentDate !== this.startDate) {
            this.props.getMealReservations(this.state.currentDate);
            this.startDate = this.state.currentDate;
        }
    }

    onWeekDayClick = weekDay => this.setState({ currentDate: this.weekDays[weekDay].date });

    renderRows = () => Object.entries(this.props.mealReservationsList).map(([mealDescription, rows]) => {
        return (
            <React.Fragment key={mealDescription}>
                {this.renderRow(mealDescription)}
                {rows.map((row, index) => this.renderRow(row, index + 1))}
            </React.Fragment>
        );
    });

    renderRow = (row = null, index = null) => {
        return (
            row && !index ? (
                <tr key={row} className="header">
                    <td className="header" colSpan={2}>{row}</td>
                </tr>
            ) : (
                <tr key={row ? index : "header"}>
                    <td className={row ? "content" : "header"}>{row ? row.posDescription : "Potrawa"}</td>
                    <td className={row ? "content" : "header"}>{row ? row.count : "Liczba rezerwacji"}</td>
                </tr>
            )
        );
    };

    render() {
        return (
            <React.Fragment>
                <div className="meal-reservation-list-component ui container">
                    <div className={`ui ${this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? "four" : "two"} item menu`}>
                        <Link to="/meal-reservations/my" className="active item">
                            <div className="content">Rezerwacje</div>
                        </Link>
                        <Link to="/meal-orders/my" className="item">
                            <div className="content">Moje zamówienia</div>
                        </Link>
                        {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                            <React.Fragment>
                                <Link to="/meal-orders/today" className="item">
                                    <div className="content">Korekty zamówień</div>
                                </Link>
                                <Link to="/meal-orders/reports" className="item">
                                    <div className="content">Zestawienia</div>
                                </Link>
                            </React.Fragment>
                        ) : null}
                    </div>
                    {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                        <div className="ui three item menu">
                            <Link to="/meal-reservations/my" className="item">
                                <div className="content">Moje rezerwacje</div>
                            </Link>
                            <Link to="/meal-reservations" className="active item">
                                <div className="content">Rezerwacje pracowników</div>
                            </Link>
                            <Link to="/menus/edit" className="item">
                                <div className="content">Edycja menu</div>
                            </Link>
                        </div>
                    ) : null}
                    <div className="ui five item menu">
                        {["Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek"].map((weekDay, index) => {
                            const weekDayDate = this.weekDays.length > index ? this.weekDays[index].date : "";
                            return (
                                <div className={`${weekDayDate === this.state.currentDate ? "active " : ""}link item`} onClick={() => this.onWeekDayClick(index)} key={index}>
                                    <div className="content">{weekDay}</div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="ui divider" />
                    <div className="ui container">
                        {Object.keys(this.props.mealReservationsList).length ? (
                            <React.Fragment>
                                <div className="ui large header">
                                    <div className="content">Rezerwacje na dzień {this.state.currentDate}:</div>
                                </div>
                                <table className="content">
                                    <colgroup>
                                        <col style={{ width: "75%" }} />
                                        <col style={{ width: "25%" }} />
                                    </colgroup>
                                    <tbody>
                                        {this.renderRow()}
                                        {this.renderRows()}
                                    </tbody>
                                </table>
                            </React.Fragment>
                        ) : (
                            <div className="ui grid">
                                <div className="column">
                                    <h2 className="ui icon header">
                                        <i className="utensils icon"></i>
                                        <div className="content">Nie odnaleziono rezerwacji na ten dzień</div>
                                    </h2>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    mealReservationsList: state.mealReservation.list
});

export default connect(mapStateToProps, { getMealReservations })(MealReservationList);